import moment from 'moment'

export default function (value) {
    if (value === undefined || value === null)
        return ''

    return moment.utc(value).local().format('DD/MM/YY')
}